import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({ activeSection, onNavClick }) => {
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleNavClick = (section) => {
        onNavClick(section);
        setIsMenuOpen(false);
    };

    return (
        <nav className="navbar" style={{ boxShadow: scrolled ? '0 2px 20px rgba(0, 0, 0, 0.15)' : '0 2px 10px rgba(0, 0, 0, 0.1)' }}>
            <div className="container">
                <div className="nav-wrapper">
                    <div className="logo">
                        <h2>F.A <span>Real Estate</span></h2>
                    </div>
                    <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
                        <li>
                            <a 
                                href="#home" 
                                className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleNavClick('home');
                                }}
                            >
                                Home
                            </a>
                        </li>
                        <li>
                            <a 
                                href="#properties" 
                                className={`nav-link ${activeSection === 'properties' ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleNavClick('properties');
                                }}
                            >
                                Properties
                            </a>
                        </li>
                        <li>
                            <a 
                                href="#about" 
                                className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleNavClick('about');
                                }}
                            >
                                About
                            </a>
                        </li>
                        <li>
                            <a 
                                href="#services" 
                                className={`nav-link ${activeSection === 'services' ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleNavClick('services');
                                }}
                            >
                                Services
                            </a>
                        </li>
                        <li>
                            <a 
                                href="#contact" 
                                className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleNavClick('contact');
                                }}
                            >
                                Contact
                            </a>
                        </li>
                        {!isHomePage && (
                            <li>
                                <Link 
                                    to="/admin/login" 
                                    className="nav-link admin-link"
                                >
                                    <i className="fas fa-user-shield"></i> Admin
                                </Link>
                            </li>
                        )}
                    </ul>
                    <div 
                        className="nav-toggle" 
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
